import { LabOrder } from '@dataTypes/lab.types'

export const labInitialData: LabOrder[] = [
  {
    orderNo: 'LAB-100003',
    requestedOn: '2025-05-01',
    patientName: 'Alice Johnson',
    labWorkType: 'Periodontics',
    providerName: 'Dr. Lisa Wong',
    partnerLabName: 'Pearl Dental Lab',
    dueDate: '2025-05-15',
    priority: 'Normal',
    totalAmount: 280,
    description: 'Deep Cleaning - Full Mouth',
    completionDate: '2025-05-15',
    status: 'Pending',
    prescriptions: [
      {
        procedureType: 'Scaling and Root Planing',
        region: 'Full Mouth',
        material: 'N/A',
        shadeNo: '',
        instructions: 'Focus on lower anterior',
      },
    ],
    attachments: [
      {
        fileName: 'precleaning.jpg',
        fileType: 'jpg',
        dateTaken: '2025-04-28',
      },
    ],
  },
  {
    orderNo: 'LAB-100004',
    requestedOn: '2025-04-29',
    patientName: 'Michael Carter',
    labWorkType: 'Implantology',
    providerName: 'Dr. David Lee',
    partnerLabName: 'SmileWorks Lab',
    dueDate: '2025-05-10',
    priority: 'Urgent',
    totalAmount: 600,
    description: 'Implant Crown - Upper Right 1',
    completionDate: '2025-05-10',
    status: 'Tx.Review',
    prescriptions: [
      {
        procedureType: 'Implant Crown',
        region: 'Upper Right Central',
        material: 'Titanium/Porcelain',
        shadeNo: 'A1',
        instructions: 'Adjust occlusion carefully',
      },
    ],
    attachments: [
      {
        fileName: 'implantPlan.png',
        fileType: 'png',
        dateTaken: '2025-04-26',
      },
    ],
  },
  {
    orderNo: 'LAB-100005',
    requestedOn: '2025-05-02',
    patientName: 'Samantha Green',
    labWorkType: 'Orthodontics',
    providerName: 'Dr. Eric Kim',
    partnerLabName: 'Align Precision Lab',
    dueDate: '2025-05-20',
    priority: 'Normal',
    totalAmount: 350,
    description: 'Clear Retainer Fabrication',
    completionDate: '2025-05-20',
    status: 'Preparing',
    prescriptions: [
      {
        procedureType: 'Retainer',
        region: 'Full Upper & Lower',
        material: 'Clear Thermoplastic',
        shadeNo: '',
        instructions: 'Ensure tight fit; trim distal edges',
      },
    ],
    attachments: [
      {
        fileName: 'scan_upper_lower.stl',
        fileType: 'stl',
        dateTaken: '2025-05-01',
      },
    ],
  },
  {
    orderNo: 'LAB-100006',
    requestedOn: '2025-04-30',
    patientName: 'John Delgado',
    labWorkType: 'Prosthodontics',
    providerName: 'Dr. Amy Patel',
    partnerLabName: 'CrownMasters Lab',
    dueDate: '2025-05-12',
    priority: 'Urgent',
    totalAmount: 720,
    description: 'Zirconia Bridge - Lower Left 5–7',
    completionDate: '2025-05-12',
    status: 'Completed',
    prescriptions: [
      {
        procedureType: 'Bridge',
        region: 'Lower Left 5–7',
        material: 'Zirconia',
        shadeNo: 'B2',
        instructions: 'Check contact with adjacent teeth',
      },
    ],
    attachments: [
      {
        fileName: 'bridge_design.jpg',
        fileType: 'jpg',
        dateTaken: '2025-04-27',
      },
    ],
  },
  {
    orderNo: 'LAB-100007',
    requestedOn: '2025-05-03',
    patientName: 'Brian Torres',
    labWorkType: 'Restorative',
    providerName: 'Dr. Monica Reyes',
    partnerLabName: 'BrightSmile Lab',
    dueDate: '2025-05-18',
    priority: 'Normal',
    totalAmount: 400,
    description: 'Onlay - Upper Left 4',
    completionDate: '',
    status: 'Cancelled',
    prescriptions: [
      {
        procedureType: 'Onlay',
        region: 'Upper Left 4',
        material: 'Ceramic',
        shadeNo: 'A2',
        instructions: 'Minimize occlusal thickness',
      },
    ],
    attachments: [
      {
        fileName: 'prep_upper_left4.jpg',
        fileType: 'jpg',
        dateTaken: '2025-05-02',
      },
    ],
  },
  {
    orderNo: 'LAB-100008',
    requestedOn: '2025-05-05',
    patientName: 'Natalie Reed',
    labWorkType: 'Crown & Bridge',
    providerName: 'Dr. Kevin Chu',
    partnerLabName: 'Everest Dental Studio',
    dueDate: '2025-05-19',
    priority: 'Urgent',
    totalAmount: 540,
    description: 'PFM Crown - Lower Right 6',
    completionDate: '2025-05-08',
    status: 'Out For Delivery',
    prescriptions: [
      {
        procedureType: 'Crown',
        region: 'Lower Right 6',
        material: 'Porcelain-Fused-to-Metal',
        shadeNo: 'C3',
        instructions: 'Ensure adequate buccal clearance',
      },
    ],
    attachments: [
      {
        fileName: 'prep_lower_right6.jpg',
        fileType: 'jpg',
        dateTaken: '2025-05-04',
      },
    ],
  },
]
